import { MAX_DISCOUNT_PCT } from '../config/constants';

export const validateRequired = (value: string, label: string): string | null => {
  return value.trim().length === 0 ? `${label} is required.` : null;
};

export const validateEmail = (value?: string): string | null => {
  if (!value) {
    return null;
  }

  return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value) ? null : 'Invalid email address.';
};

export const validateVatNumber = (value?: string): string | null => {
  if (!value) {
    return null;
  }

  return /^[A-Z0-9-]{6,20}$/i.test(value) ? null : 'Invalid VAT number format.';
};

export const validateDiscountPct = (value: number): string | null => {
  return value >= 0 && value <= MAX_DISCOUNT_PCT ? null : `Remise maximale autorisée : ${MAX_DISCOUNT_PCT}%`;
};
